import { IBannerModel } from './Types';

export default (banners: IBannerModel[]) => {
  return banners.map((banner: IBannerModel) => {
    return {
      type: banner.type || '',
      style: banner.style || '',
    };
  });
};
